import { ReplaceOp } from './ops';

/**
 * Tests if the passed value is a replace operation.
 * @param val The value to check.
 */
export default (val: unknown): val is ReplaceOp =>
  val && typeof (val as any).replace === 'string';
